"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgWave(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 5,
    preserveAspectRatio: "xMinYMin"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#17181A",
    d: "M0 4c1.199-.504 2.167-1.504 2.906-3 1.64 2.63 5.904 3.232 7.997 0 2.34 2.18 6.018 3.684 8.102 0C19.99 2.077 21.39 3.343 23 3.246"
  }));
}

var MemoSvgWave = /*#__PURE__*/React.memo(SvgWave);
var _default = MemoSvgWave;
exports["default"] = _default;